import { useState } from 'react';
// @mui
import { List, Box } from '@mui/material';
// type
import type { NavSectionProps } from '../type';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

export function NavSection({
  navConfig,
  isCollapse = false,
  ...other
}: NavSectionProps): JSX.Element {
  const [openMenuIndex, setOpenMenuIndex] = useState<number | undefined>(
    undefined
  );

  return (
    <Box {...other}>
      {navConfig.map((group) => (
        <List key={group.subheader} disablePadding>
          {group.items.map((list, index) => (
            <NavListRoot
              key={list.title}
              list={list}
              isCollapse={isCollapse}
              index={index}
              openMenuIndex={openMenuIndex}
              setOpenMenuIndex={setOpenMenuIndex}
            />
          ))}
        </List>
      ))}
    </Box>
  );
}
